import { useQuery } from '@tanstack/react-query';
import { mockClinics, Clinic } from '@mocks/clinics';
import { queryKeys } from '../queryKeys';

// Mock API call
const fetchClinics = async (): Promise<Clinic[]> =>
  new Promise(resolve => {
    setTimeout(() => resolve(mockClinics), 400);
  });

export const useClinics = () =>
  useQuery({
    queryKey: queryKeys.clinics,
    queryFn: fetchClinics,
    staleTime: 10 * 60 * 1000, // 10 minutes
  });
